module.exports = __webpack_public_path__ + "img/expense_category.51e2bbf1.png";